module.exports = __webpack_public_path__ + "img/bin.c88779bf.svg";